import { memo, useMemo } from "react";
import SpectrumPreview from "./SpectrumPreview";
import Button from "../../components/Button";
import styles from "./spectraArray.module.css";

const SpectraArray = ({ data, link, ...rest }) => {
  const content = useMemo(() => {
    if (!data) return null;
    return data?.map((spectrum_id) => {
      const spectrumPreview = (
        <SpectrumPreview
          key={spectrum_id}
          id={spectrum_id}
          viewOnly
          size={"small"}
        />
      );
      if (typeof link === "function") {
        return (
          <Button key={spectrum_id} to={link(spectrum_id)} inline>
            {spectrumPreview}
          </Button>
        );
      }
      return spectrumPreview;
    });
  }, [data, link]);

  return <div className={styles.spectraArray}>{content}</div>;
};

export default memo(SpectraArray);
